import {DataService} from '../Services/data.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {WebSocketService} from '../Services/webSocket.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Person} from '../Model/Person';
import {PersonLunch} from '../Model/PersonLunch';

@Component({
  selector: 'app-HRAndFinance',
  templateUrl: './HRAndFinance.component.html',
  styleUrls: ['./HRAndFinance.component.css'],
})

export class HRAndFinanceComponent implements OnInit {

  year: number;
  month: string;

  years: number[];
  startYear = 2018;
  monthsOfTheYear =['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  extensions;

  extension: string;

  exportRunning = false;
  exportDone = false;

  months: string[];

  constructor(private dataService: DataService, public webSocketService: WebSocketService, private router: Router, private modalService: NgbModal) {
    this.year = new Date().getFullYear();

    this.extensions = [
      {name: "Excel", extension: ".xls"},
      {name: "Pdf", extension: ".pdf"},
      {name: "Csv", extension: ".csv"}
    ];
    this.extension = this.extensions[0].extension;
    this.years = [];
    this.months = [];
  }

  /**
   * check the role of the currently logged in {@link Person}
   * if {@link Person} doesn't has role 6 ('Kantine/Canteen') the user will be redirected to the login screen
   */
  checkRole(): void {
    if (this.dataService.role.id !== 4 && this.dataService.role.id !== 5) {
      this.router.navigateByUrl('aanmelden');
    }
  }

  /**
   * on Init the date in variable Today will be set to today's date
   * The Role of the user will be check with {@link checkRole}
   * all {@link PersonLunch} will be get where the guest amount is not 0
   */
  ngOnInit(): void {
    this.checkRole();
    const thisYear = new Date().getFullYear();
    const yearsBetween = thisYear - this.startYear;
    for(var i = 0; i< yearsBetween + 1; i++) {
      this.years.push(this.year - i);
    }
    this.getMonths();
    this.month = new Date().getMonth().toString();
  }

  /**
   * get available months in this year
   */
  getMonths(): void {
	  this.months = this.monthsOfTheYear;
    /*if(this.year === new Date().getFullYear()) {
      for(let i = 0; i < new Date().getMonth() + 1; i++) {
       this.months.push(this.monthsOfTheYear[i]);
      }
    } else {
      this.months = this.monthsOfTheYear;
    }*/
  }

  /**
   * export telfort total costs per month as CSV, PDF or XLS
   */
  exportTelfort(): void {
    let dateFrom = new Date(this.year, parseInt(this.month), 1);
    let dateTo = new Date(this.year, parseInt(this.month) + 1, 0);
    const date = [dateFrom, dateTo];
    console.log(date);
    this.dataService.getTelfortExport(date, this.extension);
  };

  /**
   * export Inther costs per person as CSV, PDF or XLS
   */
  getIntherExportPerPerson(): void {
    console.log(this.year);
    console.log(this.month);
    let dateFrom = new Date(this.year, parseInt(this.month), 1);
    let dateTo = new Date(this.year, parseInt(this.month) + 1, 0);
    const date = [dateFrom, dateTo];
    console.log(date);
    this.dataService.getIntherExportPerPerson(date, this.extension);
  }

  /**
   * export Telfort costs per person as CSV, PDF or XLS
   */
  getTelfortExportPerPerson(): void {
    let dateFrom = new Date(this.year, parseInt(this.month), 1);
    let dateTo = new Date(this.year, parseInt(this.month) + 1, 0);
    const date = [dateFrom, dateTo];
    console.log(date);
    this.dataService.getTelfortExportPerPerson(date, this.extension);
  }

  exportToAfas(): void {
    this.exportRunning = true;
    this.exportDone = false;
    console.log(this.year);
    console.log(this.month);
    let dateFrom = new Date(this.year, parseInt(this.month), 1);
    let dateTo = new Date(this.year, parseInt(this.month) + 1, 0);
    const date = [dateFrom, dateTo];
    console.log(date);
    this.dataService.exportToAfas(date).subscribe((data) => {
      this.exportRunning = false;
      this.exportDone = true;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/HRAndFinance/HRAndFinance.component.ts